import { render, staticRenderFns } from "./PatrimoniosList.vue?vue&type=template&id=c48a4d32&scoped=true"
import script from "./PatrimoniosList.vue?vue&type=script&lang=js"
export * from "./PatrimoniosList.vue?vue&type=script&lang=js"
import style0 from "./PatrimoniosList.vue?vue&type=style&index=0&id=c48a4d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48a4d32",
  null
  
)

export default component.exports